import React, { useState } from 'react'
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import StudentHeader from './StudentHeader';
import { closeModal, ToastMain ,SweetAlertShow} from '../../master/Master';
import { CreateSyllabus } from '../../../api/SyllabusService';

const MeritStudent = () => {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const response = await CreateSyllabus();
            if (response?.data?.status) {
                closeModal('addfield')
                SweetAlertShow('sucess','Successfully',response?.data?.message )
               
            } else {
                SweetAlertShow('info','Warning',response?.data?.message)
              
            }
        } catch (error) {
            SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
           
        } finally {
            setLoading(false)
        }
    }
    return (
        <>
            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
                    style={{ zIndex: 9999 }}
                >
                    <div className="sk-chase sk-primary display-1">
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                        <div className="sk-chase-dot" />
                    </div>
                </div>
            )}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="container-fluid mt-2">
                            <div className="row custom-scroll-layout">
                                <div className="col-md-2 left-pane">
                                    <StudentHeader data={'Student Portal'} />
                                </div>
                                <div className="col-md-10 right-pane col-12">

                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className='text-primary'>Selection / Merit List</h4>
                                                <button className='btn btn-sm btn-outline-primary' data-bs-target="#fieldAdd" data-bs-toggle="modal">Add field</button>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-3">
                                                    <div className="form-floating form-floating-outline">
                                                        <input className='form-control' type="text" id='search' placeholder='Search' />
                                                        <label htmlFor="search">Search</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-floating form-floating-outline">
                                                        <input className='form-control' type="text" placeholder='Batcb' />
                                                        <label htmlFor="search">Batch</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card mt-2">
                                        <div className="card-body">

                                            <div className="table-responsive">
                                                <table className='table table-primary text-center'>
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Batch</th>
                                                            <th>Year</th>
                                                            <th>Attempt</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className='text-capitalize'>
                                                        <tr>
                                                            <td>Manoj</td>
                                                            <td>Udaan</td>
                                                            <td>2025</td>
                                                            <td>1st</td>
                                                            <td>View</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Field Add Modal */}


            <div
                className="modal fade"
                id="fieldAdd"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header bg-label-primary py-3">
                            <h1 className="modal-title fs-5">Field Add</h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>


                        <form onSubmit={handleSubmit}>
                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                id="name"
                                                className="form-control input-uppercase"
                                                type="text"
                                                name="name"
                                                placeholder="Name"
                                            />
                                            <label htmlFor="name">Name</label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-floating form-floating-outline">
                                            <input
                                                id="year"
                                                className="form-control"
                                                type="text"
                                                name="year"
                                                placeholder="Year"
                                            />
                                            <label htmlFor="year">Year</label>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="modal-footer bg-label-primary py-3">
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-primary px-5"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                    ) : (
                                        "Submit"
                                    )}
                                    {loading ? " Submitting..." : ""}
                                </button>
                            </div>
                        </form>


                    </div>
                </div>
            </div>




        </>

    )
}

export default MeritStudent
